<div fxLayout="row">
    <div fxFlex="65">
        <div *ngIf="header">
            FUND RECAP
        </div>
        <div *ngIf="!header">
            {{ fund.Fund.Code }} - {{ fund.Fund.Description }}
        </div>
    </div>
    <div fxFlex="35" fxLayout="row" fxLayoutAlign="end">
        <div *ngIf="header">
            AMOUNT
        </div>
        <div *ngIf="!header">
            {{ fund.TotalAmount | currency }}
        </div>
    </div>
</div>